import React, { useState, useEffect } from 'react';

import styles from './UiLibraryComponent.module.css';
import { IRadioButtonGroupProps } from '@model/UIComponents.model';

const RadioButton: React.FC<IRadioButtonGroupProps> = ({
  label,
  options,
  defaultValue,
  onChange,
  error,
  disabled = false,
  customClassName = '',
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue ?? '');

  useEffect(() => {
    if (defaultValue) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue]);

  const handleChange = (value: string) => {
    if (!disabled) {
      setSelectedValue(value);
      onChange(value);
    }
  };

  return (
    <div className={styles.inputContainer}>
      <label className={styles.inputLabel} data-testid="radio_label">
        {label}
      </label>

      <div className={`${styles.radioGroup} ${customClassName}`}>
        {options.map((option, index) => (
          <label key={index} className={styles.radioOption}>
            <input
              type="radio"
              name="radio-group"
              value={option.value}
              checked={selectedValue === option.value}
              disabled={disabled}
              onChange={() => handleChange(option.value)}
              className={`${styles.radioInput} ${
                error ? styles.inputWithError : ''
              }`}
              data-testid={`radio_option_${option.value}`}
            />
            {option.label}
          </label>
        ))}
      </div>

      {error && (
        <div className={styles.errorMessage} data-testid="radio_error">
          {error}
        </div>
      )}
    </div>
  );
};

export default RadioButton;
